import useValidateFormPromise from '@gef-ui/form-core/hooks/form/useValidateFormPromise';
import useFormDataLazy from '@gef-ui/form-core/hooks/state/useFormDataLazy';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import identity from "ramda/es/identity";
import React, { useCallback } from 'react';
import { useFieldDefaultValue } from '../utils';
export const COMPONENT_NAME = 'SubmitButton';
const SubmitButton = (inProps)=>{
    const props = useFieldDefaultValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { onClick, onClickError = identity, skipValidation, text, ...other } = props;
    const getFormData = useFormDataLazy();
    const validateFormPromise = useValidateFormPromise();
    const buttonClickHandler = useCallback(async ()=>{
        const formData = await getFormData();
        if (!skipValidation) {
            try {
                await validateFormPromise();
                onClick(formData);
            } catch (e) {
                onClickError(formData, e);
            }
        } else {
            onClick(formData);
        }
    }, [
        getFormData,
        onClick,
        skipValidation,
        validateFormPromise,
        onClickError
    ]);
    return /*#__PURE__*/ React.createElement(Button, {
        ...other,
        onClick: buttonClickHandler
    }, text);
};
SubmitButton.propTypes = {
    onClick: PropTypes.func,
    onClickError: PropTypes.func,
    skipValidation: PropTypes.bool,
    text: PropTypes.string
};
export default SubmitButton;
